import axios from 'axios';
import { API_BASE_URL } from '@/constants';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useFilters } from './FiltersContext';

export const useFetchPets = (
  status: PetStatus,
  initialData?: { results: Array<Pet>; next: string | null },
) => {
  const { filters } = useFilters();

  const fetchPets = async ({
    pageParam = 1,
  }): Promise<{ results: Array<Pet>; next: string | null }> => {
    const requestFilters = { ...filters };
    if (requestFilters.race === 'mestizo') {
      delete requestFilters['race'];
    }

    const response = await axios.get(`${API_BASE_URL}/pets/`, {
      params: {
        status,
        is_active: true,
        page: pageParam,
        ...requestFilters,
      },
    });
    return response.data;
  };

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ['pets', status, filters],
    queryFn: fetchPets,
    initialPageParam: 1,
    getNextPageParam: (lastPage: { results: Array<Pet>; next: string | null }) => {
      const nextPageUrl = lastPage.next;
      if (!nextPageUrl) return undefined;
      const urlParams = new URLSearchParams(nextPageUrl.split('?')[1]);
      if (!urlParams.has('page')) return undefined;
      const page = urlParams.get('page');
      if (!page) return undefined;
      if (isNaN(Number(page))) return undefined;
      return Number(page);
    },
    initialData: initialData
      ? {
          pageParams: [1],
          pages: [initialData],
        }
      : undefined,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  };
};
